import type { NpsConfig } from '@features/partners/builder/settings/nps/models/nps';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable()
export class NpsWebservice {
  readonly #http = inject(HttpClient);

  public get(partnerId: string): Observable<NpsConfig> {
    return this.#http.get<NpsConfig>(`${environment.api.obendy}/v1/partner-revision/${partnerId}/nps`);
  }

  public put({ partnerId, payload }: { partnerId: string; payload: NpsConfig }): Observable<NpsConfig> {
    return this.#http.put<NpsConfig>(`${environment.api.obendy}/v1/partner-revision/${partnerId}/nps`, payload);
  }
}
